import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

export class ZIDXWixDashboard implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxWixDashboardContainer";
    }
    render(){
        // console.log("wix dashboard");

    }
}